import { Vue } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios from 'axios';
import 'url-search-params-polyfill';
import {CONFIG_ENV} from '@/config';
import iNomCateg from '@/types/iNomCateg';
import nomenclatoare from '@/store/nomenclatoare';

interface TAjaxResponseNomHrOrg {
  status: string;
  message: string;
  hr_org: any;
  //rows: iNomCateg[];
}

interface TAjaxResponseEditRegistru {
  status: string;
  message: string;
}

export class ServicesHrOrg {
  public static async getHrOrg(): Promise<TAjaxResponseNomHrOrg> {
    // tslint:disable-next-line:no-console
    const response = await axios.get(`${CONFIG_ENV.URL_NOM.hr_nom_org}`);
    return response.data;
  }

}
